import { fetchUserIfNeeded } from '@lootboy/lib/actions/UserActions';
import useFetchSelector from '@lootboy/lib/hooks/useFetchSelector';
import { userSelector } from '@lootboy/lib/selectors';

import { evalIsUserSubscribed } from '~/redux/selectors';

export default () =>
  evalIsUserSubscribed(useFetchSelector(fetchUserIfNeeded, userSelector));
